<div
  #container
  [ngClass]="{
    'form-floating':
      !noLabel &&
      !['radio', 'checkbox', 'submit', 'button'].includes(type ?? ''),
    'form-check': type === 'checkbox',
    'input__container': customInput
  }"
  *appLet="{
    appCopy: appCopy$ | async
  } as $comp"
>
  <ng-content></ng-content>

  <ng-container *ngIf="label && !noLabel">
    <label
      *ngIf="type !== 'radio'; else radioLabel"
      [for]="id"
      class="form-label form-{{ type }}-label"
      [innerHtml]="
        (required ? (label | requiredField) : label)
          | safeHtml: SanitizerValueType.HTML
      "
    >
    </label>

    <ng-template #radioLabel>
      <!-- 
        the "btnCheckbox" directive doesn't appear to do a thing,
        but ngx-bootstrap says to use it
      -->
      <label btnCheckbox [for]="id" class="btn btn-outline-secondary">
        {{ required ? (label | requiredField) : label }}
      </label>
    </ng-template>
  </ng-container>

  @if (withEmailTip && showEmailTip) {
    <div class="email-tip-box">
      <div
        [appEmailTip]="'@gmail.com'"
        [searchTerm]="inputValue"
        (copyEmail)="copyEmail($event)"
      ></div>
      <div
        [appEmailTip]="'@hotmail.com'"
        [searchTerm]="inputValue"
        (copyEmail)="copyEmail($event)"
      ></div>
      <div
        [appEmailTip]="'@yahoo.com'"
        [searchTerm]="inputValue"
        (copyEmail)="copyEmail($event)"
      ></div>
      <div
        [appEmailTip]="'@outlook.com'"
        [searchTerm]="inputValue"
        (copyEmail)="copyEmail($event)"
      ></div>
    </div>
  }
  @if (!hideErrorLabel && control && $comp.appCopy) {
    <app-input-errors
      [control]="control"
      [suppressErrors]="suppressErrors"
      [extraErrors]="extraErrors"
      [errors]="$comp.appCopy.errors"
    ></app-input-errors>
  }
</div>
